var _path, _path2, _path3, _path4, _path5, _path6, _mask, _g, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 75,
    viewBox: "0 0 230 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.579 56.4253C98.6365 56.4253 96.1553 55.7696 94.1349 54.4581C92.1499 53.1111 90.6612 51.3388 89.6687 49.1412C88.6762 46.9435 88.1799 44.5332 88.1799 41.9101C88.1799 39.2871 88.6585 36.8768 89.6155 34.6791C90.608 32.446 92.1145 30.656 94.1349 29.309C96.1553 27.9621 98.6365 27.2886 101.579 27.2886C104.521 27.2886 107.002 27.9621 109.022 29.309C111.043 30.6205 112.549 32.3751 113.542 34.5728C114.534 36.7705 115.03 39.1808 115.03 41.8038C115.03 44.4268 114.534 46.8549 113.542 49.088C112.549 51.2857 111.043 53.058 109.022 54.4049C107.002 55.7519 104.521 56.4253 101.579 56.4253ZM101.579 50.4704C103.634 50.4704 105.176 49.6551 106.204 48.0246C107.268 46.3586 107.799 44.285 107.799 41.8038C107.799 39.3226 107.268 37.2844 106.204 35.6893C105.176 34.0588 103.634 33.2436 101.579 33.2436C99.5227 33.2436 97.9808 34.0588 96.9529 35.6893C95.9249 37.2844 95.4109 39.3226 95.4109 41.8038C95.4109 44.285 95.9249 46.3586 96.9529 48.0246C98.0162 49.6551 99.5581 50.4704 101.579 50.4704Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.236 27.9266H127.627V32.446H127.999C128.389 31.4535 129.204 30.337 130.445 29.0964C131.686 27.8557 133.493 27.2354 135.868 27.2354C137.711 27.2354 139.253 27.6608 140.494 28.5115C141.734 29.3622 142.638 30.2661 143.206 31.2231C143.808 32.1447 144.163 32.8182 144.269 33.2436H144.641C145.066 32.1093 145.953 30.8332 147.3 29.4154C148.646 27.9621 150.72 27.2354 153.52 27.2354C155.966 27.2354 157.898 27.8735 159.316 29.1495C160.769 30.3901 161.779 31.8966 162.346 33.6689C162.949 35.4058 163.25 37.0895 163.25 38.72V56H155.86V39.4644C155.86 37.5503 155.364 36.097 154.371 35.1045C153.379 34.112 152.173 33.6157 150.756 33.6157C149.302 33.6157 148.044 34.1297 146.981 35.1577C145.953 36.1856 145.439 37.6212 145.439 39.4644V56H138.048V39.4644C138.048 37.5503 137.552 36.097 136.559 35.1045C135.567 34.112 134.362 33.6157 132.944 33.6157C131.491 33.6157 130.232 34.1297 129.169 35.1577C128.141 36.1856 127.627 37.6212 127.627 39.4644V56H120.236V27.9266Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.999 27.9266H177.336V56H169.999V27.9266ZM173.614 23.0882C172.444 23.0882 171.47 22.6983 170.69 21.9185C169.91 21.1033 169.52 20.1285 169.52 18.9942C169.52 17.8245 169.91 16.8497 170.69 16.0699C171.47 15.2901 172.444 14.9002 173.614 14.9002C174.784 14.9002 175.759 15.3078 176.538 16.1231C177.318 16.9029 177.708 17.8599 177.708 18.9942C177.708 20.1285 177.318 21.1033 176.538 21.9185C175.759 22.6983 174.784 23.0882 173.614 23.0882Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M184.621 27.9266H192.065V32.2333H192.437C193.075 30.8509 194.103 29.6812 195.521 28.7242C196.939 27.7317 198.658 27.2354 200.678 27.2354C204.329 27.2354 206.899 28.4052 208.388 30.7446C209.912 33.0841 210.674 35.7425 210.674 38.72V56H203.337V39.9429C203.337 37.887 202.84 36.2742 201.848 35.1045C200.891 33.9348 199.526 33.3499 197.754 33.3499C195.875 33.3499 194.457 33.9702 193.5 35.2108C192.543 36.416 192.065 37.9933 192.065 39.9429V56H184.621V27.9266Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M217.404 27.9266H224.742V56H217.404V27.9266ZM221.02 23.0882C219.85 23.0882 218.875 22.6983 218.096 21.9185C217.316 21.1033 216.926 20.1285 216.926 18.9942C216.926 17.8245 217.316 16.8497 218.096 16.0699C218.875 15.2901 219.85 14.9002 221.02 14.9002C222.19 14.9002 223.164 15.3078 223.944 16.1231C224.724 16.9029 225.114 17.8599 225.114 18.9942C225.114 20.1285 224.724 21.1033 223.944 21.9185C223.164 22.6983 222.19 23.0882 221.02 23.0882Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32 2.0198C35.7128 -0.123789 40.2872 -0.123789 44 2.0198L65.775 14.5916C69.4878 16.7352 71.775 20.6967 71.775 24.9839V50.1275C71.775 54.4147 69.4878 58.3762 65.775 60.5198L44 73.0916C40.2872 75.2352 35.7128 75.2352 32 73.0916L10.225 60.5198C6.51222 58.3762 4.22504 54.4147 4.22504 50.1275V24.9839C4.22504 20.6967 6.51222 16.7352 10.225 14.5916L32 2.0198Z",
    fill: "url(#paint0_linear)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 68,
    height: 75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 2.0198C35.7128 -0.123789 40.2872 -0.123789 44 2.0198L65.775 14.5916C69.4878 16.7352 71.775 20.6967 71.775 24.9839V50.1275C71.775 54.4147 69.4878 58.3762 65.775 60.5198L44 73.0916C40.2872 75.2352 35.7128 75.2352 32 73.0916L10.225 60.5198C6.51222 58.3762 4.22504 54.4147 4.22504 50.1275V24.9839C4.22504 20.6967 6.51222 16.7352 10.225 14.5916L32 2.0198Z",
    fill: "url(#paint1_linear)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0008 39.5909C21.1299 30.9498 26.6183 22.4281 35.2594 20.5573C43.9005 18.6864 52.4222 24.1748 54.293 32.8159L56.0604 40.9791L24.7682 47.7541L23.0008 39.5909Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3301 17.9099C23.6226 20.2281 16.8218 30.7875 19.1401 41.495L21.327 51.5958C21.3282 51.6059 21.3299 51.616 21.3321 51.626C21.6345 53.0226 30.5597 52.2755 41.2672 49.9572C51.9747 47.639 60.4097 44.6275 60.1073 43.2309C60.1062 43.2257 60.105 43.2206 60.1036 43.2155L60.1053 43.2152L57.9153 33.0999C55.597 22.3924 45.0376 15.5916 34.3301 17.9099Z",
    fill: "url(#paint3_radial)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.4143,
    cy: 44.3667,
    rx: 16.0086,
    ry: 2.08808,
    transform: "rotate(-12.2164 40.4143 44.3667)",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.6779,
    cy: 44.6456,
    rx: 12.7537,
    ry: 1.40797,
    transform: "rotate(-12.2164 40.6779 44.6456)",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.7178,
    cy: 47.4128,
    rx: 19.8368,
    ry: 2.58741,
    transform: "rotate(-12.2164 40.7178 47.4128)",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8321 48.2567C57.9139 48.1297 57.9449 48.0114 57.9214 47.9029C57.6539 46.6677 50.4275 47.1839 41.7807 49.056C33.1339 50.9281 26.3411 53.4472 26.6085 54.6824C26.632 54.7909 26.7091 54.8858 26.8361 54.9675L26.6776 55.0019L31.866 78.9658C33.7381 87.6126 42.2654 93.1046 50.9122 91.2325C59.559 89.3604 65.051 80.8331 63.1789 72.1863L57.9905 48.2224L57.8321 48.2567Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3855 50.8128C58.4674 50.6859 58.4983 50.5675 58.4748 50.4591C58.2074 49.2238 50.981 49.7401 42.3342 51.6122C33.6873 53.4843 26.8945 56.0033 27.162 57.2386C27.1854 57.347 27.2626 57.442 27.3896 57.5237L27.2311 57.558L31.8661 78.9658C33.7382 87.6126 42.2654 93.1046 50.9123 91.2325C59.5591 89.3604 65.0511 80.8331 63.179 72.1863L58.544 50.7785L58.3855 50.8128Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4214 46.9687C59.5115 46.8241 59.545 46.6889 59.5181 46.5646C59.2116 45.1491 51.1784 45.687 41.5753 47.7661C31.9723 49.8453 24.4359 52.6783 24.7424 54.0938C24.7693 54.2181 24.8558 54.3273 24.9976 54.4218L24.8216 54.4599L30.253 79.5461C32.3322 89.1492 41.8024 95.2485 51.4055 93.1694C61.0085 91.0902 67.1078 81.62 65.0287 72.0169L59.5973 46.9306L59.4214 46.9687Z",
    fill: "url(#paint9_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5724 53.5264C48.018 55.7819 46.0217 58.1489 43.816 59.8299L43.6864 59.9287L43.5275 59.8924C36.7909 58.3521 32.6279 54.2576 31.0428 52.478L31.5625 52.0151C33.0899 53.7298 37.0811 57.6549 43.5233 59.1769C45.5988 57.5628 47.499 55.3085 48.9993 53.1314C50.5319 50.9075 51.628 48.7925 52.0629 47.5646L52.719 47.797C52.2568 49.102 51.1256 51.2726 49.5724 53.5264Z",
    fill: "#299AFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5663 55.3703C50.4027 58.4379 47.631 61.6536 44.5798 63.939L44.4522 64.0346L44.2965 64.0003C35.0101 61.9582 29.2886 56.444 27.1107 54.0447L27.626 53.5769C29.7446 55.9108 35.2948 61.2605 44.2899 63.2858C47.212 61.0659 49.888 57.9601 51.9976 54.9691C54.1392 51.9328 55.6776 49.0427 56.2929 47.3582L56.9467 47.597C56.3031 49.3589 54.7287 52.3046 52.5663 55.3703Z",
    fill: "#299AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6644 74.0797C28.7413 73.63 29.2164 67.6833 27.7256 60.7973C27.2901 58.7861 26.7351 56.9173 26.1158 55.2904C23.461 57.8229 21.8458 62.2732 21.6566 67.5101C23.182 71.6946 25.1422 74.4093 26.6644 74.0797Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1027 74.0322C68.9491 70.9675 66.4183 66.2707 64.107 60.8302C61.7016 55.1678 60.0411 49.8936 59.3792 46.187C63.7269 48.5121 67.8166 53.8589 69.9757 60.7465C71.4622 65.4885 71.7804 70.1532 71.1027 74.0322Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8278 54.6594C10.0232 53.8283 9.971 52.3419 11.1015 52.0971C14.3877 51.3856 17.6284 53.4728 18.3398 56.7589C18.8405 59.0711 17.9555 61.3608 16.2422 62.7628C15.5446 63.3336 14.6019 62.7901 14.4111 61.9092C13.7545 58.8761 12.4223 56.3064 10.8278 54.6594Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 8.70217,
    transform: "matrix(-0.977355 0.211605 0.211605 0.977355 22.2977 61.786)",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7593 31.9232C48.8825 32.0639 49.1289 31.9893 49.0893 31.8065C48.764 30.3037 47.2819 29.3492 45.7791 29.6745C44.2763 29.9999 43.3218 31.4819 43.6472 32.9847C43.6868 33.1676 43.942 33.1336 43.996 32.9545C44.2787 32.0168 45.0487 31.2568 46.0737 31.0349C47.0987 30.813 48.114 31.1864 48.7593 31.9232Z",
    fill: "#003F66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5695 35.3096C36.4818 35.2095 36.3067 35.2626 36.3348 35.3926C36.566 36.4603 37.619 37.1385 38.6867 36.9073C39.7544 36.6761 40.4326 35.6232 40.2014 34.5554C40.1733 34.4255 39.9919 34.4496 39.9535 34.5769C39.7525 35.243 39.2056 35.7828 38.4774 35.9405C37.7492 36.0981 37.0279 35.8329 36.5695 35.3096Z",
    fill: "#003F66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8974 37.2786C31.288 36.9775 32.986 36.4446 32.6998 35.0509C32.6964 35.0342 32.6929 35.0175 32.6893 35.0009C32.2419 32.9345 30.5087 31.5561 28.818 31.9222C27.1273 32.2882 26.1195 34.2601 26.5669 36.3264C26.5725 36.3524 26.5783 36.3783 26.5843 36.404C26.8935 37.7251 28.5713 37.5657 29.8974 37.2786Z",
    fill: "#003F66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0209 61.7942C51.8768 61.8254 51.7262 61.8008 51.6032 61.7245L46.5005 58.5924C45.163 57.771 44.7892 56.0444 45.6672 54.7434C46.0917 54.1156 46.7444 53.6786 47.5056 53.5138C48.2667 53.349 49.0423 53.4768 49.6879 53.8729L50.4007 54.3105L50.8687 53.6178C51.2931 52.9894 51.9458 52.5524 52.7075 52.3875C53.4681 52.2228 54.2437 52.3506 54.8893 52.7467C56.2274 53.568 56.6012 55.2945 55.7232 56.5956L52.3732 61.5583C52.292 61.6783 52.1657 61.7628 52.0209 61.7942Z",
    fill: "#FF3E1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.315 51.6783C31.5028 51.6376 31.6881 51.757 31.7288 51.9448C32.1448 53.8662 33.3025 58.5557 34.6031 61.9507C34.6719 62.1301 34.5821 62.3314 34.4026 62.4001C34.2232 62.4689 34.0219 62.3791 33.9532 62.1997C32.6336 58.7555 31.4671 54.0255 31.0485 52.0921C31.0078 51.9042 31.1271 51.719 31.315 51.6783Z",
    fill: "#003F66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1149 47.1124C52.3027 47.0717 52.4858 47.1812 52.5238 47.3568C52.9129 49.1535 54.0043 53.5368 55.2556 56.7038C55.3217 56.8712 55.2295 57.0612 55.0496 57.1281C54.8698 57.195 54.6703 57.1135 54.6041 56.9461C53.3347 53.7331 52.235 49.3121 51.8436 47.5041C51.8056 47.3284 51.927 47.1531 52.1149 47.1124Z",
    fill: "#003F66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1975 17.8022C33.5526 15.8052 33.989 13.6086 34.288 12.7485L34.9454 12.977C34.6746 13.7561 34.2782 15.7873 34.8598 17.5883L34.1975 17.8022Z",
    fill: "#003F66"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.9128,
    cy: 63.362,
    r: 2.4361,
    transform: "rotate(-12.2164 34.9128 63.362)",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.2382,
    cy: 10.5919,
    r: 2.78411,
    transform: "rotate(-12.2164 35.2382 10.5919)",
    fill: "url(#paint15_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0291 56.6365C53.194 57.0339 52.0284 58.8436 52.4257 60.6788L52.5383 61.1986C52.5384 61.1991 52.5385 61.1995 52.5386 61.2L53.0586 63.602C53.2776 64.6135 54.2751 65.2559 55.2866 65.0369C55.4745 64.9963 55.5938 64.811 55.5531 64.6232C55.5125 64.4353 55.3272 64.316 55.1393 64.3567C54.5035 64.4943 53.8765 64.0905 53.7389 63.4547L53.3031 61.4421L53.106 60.5315C52.79 59.0721 53.717 57.6328 55.1764 57.3168C56.6359 57.0008 58.0752 57.9278 58.3911 59.3872L58.5036 59.9068C58.5037 59.9074 58.5039 59.9079 58.504 59.9085L59.024 62.3104C59.1617 62.9462 58.7579 63.5732 58.1221 63.7109C57.9342 63.7516 57.8149 63.9368 57.8556 64.1247C57.8962 64.3125 58.0815 64.4318 58.2693 64.3911C59.2808 64.1721 59.9233 63.1746 59.7043 62.1631L59.2685 60.1505L59.2686 60.1505L59.0714 59.24C58.6741 57.4048 56.8643 56.2392 55.0291 56.6365Z",
    fill: "#003F66"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5588,
    cy: 25.7432,
    rx: 8.24508,
    ry: 4.33395,
    transform: "rotate(-35.113 30.5588 25.7432)",
    fill: "url(#paint16_radial)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5822,
    cy: 58.9578,
    rx: 2.26673,
    ry: 3.69,
    transform: "rotate(-35.113 26.5822 58.9578)",
    fill: "url(#paint17_radial)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.2675,
    cy: 32.8106,
    rx: 2.00047,
    ry: 1.74141,
    transform: "rotate(-57.9056 22.2675 32.8106)",
    fill: "url(#paint18_radial)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.025 17.6227L42.25 5.05089C39.6201 3.53251 36.3799 3.53251 33.75 5.05089L11.975 17.6227C9.34513 19.1411 7.72504 21.9471 7.72504 24.9839V50.1275C7.72504 53.1643 9.34513 55.9703 11.975 57.4887L33.75 70.0605C36.3799 71.5789 39.6201 71.5789 42.25 70.0605L64.025 57.4887C66.6549 55.9703 68.275 53.1643 68.275 50.1275V24.9839C68.275 21.9471 66.6549 19.1411 64.025 17.6227ZM44 2.0198C40.2872 -0.123789 35.7128 -0.123789 32 2.0198L10.225 14.5916C6.51222 16.7352 4.22504 20.6967 4.22504 24.9839V50.1275C4.22504 54.4147 6.51222 58.3762 10.225 60.5198L32 73.0916C35.7128 75.2352 40.2872 75.2352 44 73.0916L65.775 60.5198C69.4878 58.3762 71.775 54.4147 71.775 50.1275V24.9839C71.775 20.6967 69.4878 16.7352 65.775 14.5916L44 2.0198Z",
    fill: "url(#paint19_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 18,
    y1: 12.5557,
    x2: 54,
    y2: 65.5557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CBEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 18,
    y1: 12.5557,
    x2: 54,
    y2: 65.5557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55C1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1154FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 26.5371,
    y1: 25.7833,
    x2: 52.5371,
    y2: 40.7833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFF5FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.1317 25.7253) rotate(29.2422) scale(38.8895 51.8084)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542736,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 29.1008,
    y1: 42.8551,
    x2: 52.2802,
    y2: 46.8504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DDF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 31.6647,
    y1: 43.6264,
    x2: 49.9226,
    y2: 47.3446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CB8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F6FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 34.4274,
    y1: 44.8953,
    x2: 57.5665,
    y2: 51.4398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ECAFF",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFF3FF",
    stopOpacity: 0.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 26.1243,
    y1: 53.8791,
    x2: 56.3936,
    y2: 53.8791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.116469,
    stopColor: "#FFAA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699803,
    stopColor: "#FFD84F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF911C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 34.064,
    y1: 58.9568,
    x2: 68.2159,
    y2: 68.9976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFF5FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.9529 57.6675) rotate(42.161) scale(44.8765 57.0452)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542736,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 22.9218,
    y1: 55.9818,
    x2: 26.8323,
    y2: 74.0432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 61.9631,
    y1: 45.3772,
    x2: 70.9598,
    y2: 74.0772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 18.282,
    y1: 56.4919,
    x2: 11.2287,
    y2: 58.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 8.70217,
    y1: 0,
    x2: 8.70217,
    y2: 17.4043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 33.1261,
    y1: 62.9752,
    x2: 37.7437,
    y2: 63.9749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CA8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.4013 11.4937) rotate(-13.9837) scale(4.75123)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.289047,
    stopColor: "#8C4300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC68"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.1352 22.9139) rotate(29.3309) scale(13.8949 15.9318)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542736,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.351 57.389) rotate(48.7512) scale(6.5904 7.64403)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.1942 31.6737) rotate(42.9388) scale(4.01469 5.37553)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542736,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 38,
    y1: -1.4443,
    x2: 38,
    y2: 76.5557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26ACFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.72733af098dc2942ff5c662239fa4f9b.svg";
export { ForwardRef as ReactComponent };